export function bridgeErrorToString(error: unknown): string {
  if (typeof error === 'string') return error

  if (error instanceof Error) {
    return error.message || error.name
  }

  try {
    return JSON.stringify(error)
  } catch {
    return String(error)
  }
}
